import React, { useEffect, useState, useCallback } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { getList, URLPRIFIX, baseurl, GetRecords, UpdateRecord } from "../../functions/api";
import { contentHeader } from "../../Constancs/cssconst";
import { IoRibbon, IoNotificationsCircleOutline } from "react-icons/io5";
import { VscCalendar } from "react-icons/vsc";
import { FaRegCircleUser } from "react-icons/fa6";
import Badge from "@mui/material/Badge";
import { getFulllocal, getlocal } from "../../functions/localstorage";
import {
  registerCurrentOneSignalDevice,
  isPushSupported,
} from "../../services/oneSignalService";
import { isOneSignalReady } from "../../services/oneSignalService";
import { handleNotificationNavigation } from "../../services/notificationNavigationHelper";
// No longer needed: ListView, IoChevronForwardOutline, MdCalendarMonth, Slide, toast, ToastContainer

const Header = ({ store, setsider }) => {
  const user = getlocal("system")?.user || {};
  const [currentDate, setCurrentDate] = useState(new Date());
  const [notificationPermission, setNotificationPermission] = useState("default");

  const tableURL = "/subtask/getsubtasklist";
  const [isPopupVisible, setPopupVisible] = useState({
    notification: false,
    profile: false,
    accounts: false,
    badges: false,
  });
  const [companies, setCompanies] = useState([]);
  const [hasTasksThisMonth, setHasTasksThisMonth] = useState(false);
  const notifications = store.getsystemvalue("Notification") || [];
  const unreadNotificationCount = store.getsystemvalue("UnreadNotificationCount") || 0;

  const getDynamicTableURL = useCallback(() => {
    return user.role === 1 ? tableURL : `${tableURL}/${user.id}`;
  }, [user.id, user.role]);

  useEffect(() => {
    // Initialize OneSignal login when user is available
    if (user.id) {
      initializeNotifications();
    }

    getNotification();
    getCompanyList();
    getBadgesCount();
    fetchMonthEvents();
  }, []);

  /**
   * Initialize OneSignal for the logged-in user
   */
  const initializeNotifications = async () => {
    try {
      // Wait for OneSignal SDK to be ready (timeout after ~10s)
      const start = Date.now();
      while (!isOneSignalReady() && Date.now() - start < 10000) {
        await new Promise((r) => setTimeout(r, 250));
      }

      if (!isOneSignalReady()) {
        console.warn("[Header] OneSignal SDK not ready after timeout, skipping login");
      } else {
        const token = getlocal("system")?.token;
        await registerCurrentOneSignalDevice(user, baseurl, token);
      }
    } catch (error) {
      console.error("[Header] Error initializing notifications:", error);
    }
  };

  /**
   * Handle enabling notifications
   */
  const handleEnableNotifications = async () => {
    try {
      if (!isPushSupported()) {
        console.warn("[Header] Push notifications not supported in this browser");
        return;
      }

      const token = getlocal("system")?.token;
      const registered = await registerCurrentOneSignalDevice(user, baseurl, token);
      setNotificationPermission(registered ? "granted" : "default");
      console.log("[Header] OneSignal device registration:", registered);
    } catch (error) {
      console.error("[Header] Error enabling notifications:", error);
    }
  };

  /**
   * Mark all notifications as read
   */
  const handleMarkAllAsRead = async () => {
    try {
      if (user.id) {
        await UpdateRecord(`/api/notifications/markallread/${user.id}`);
        store.setsystemvalue(
          "Notification",
          notifications.map((item) => ({ ...item, isRead: true }))
        );
        store.setsystemvalue("UnreadNotificationCount", 0);
      }
    } catch (error) {
      console.error("[Header] Error marking all notifications as read:", error);
    }
  };

  /**
   * Handle notification click - navigate to task/item using helper
   */
  const handleNotificationClick = async (notification) => {
    try {
      if (notification?.id && !notification?.isRead) {
        await UpdateRecord(`/api/notifications/${notification.id}/read`);
        store.setsystemvalue(
          "Notification",
          notifications.map((item) =>
            item.id === notification.id ? { ...item, isRead: true } : item
          )
        );
        store.setsystemvalue(
          "UnreadNotificationCount",
          Math.max(unreadNotificationCount - 1, 0)
        );
      }

      handleNotificationNavigation(
        notification,
        (url) => {
          store.navTo(url);
          togglePopup("notification");
        },
        URLPRIFIX
      );
    } catch (error) {
      console.error("[Header] Error handling notification click:", error);
      store.navTo(`/${URLPRIFIX}/dashboard`);
    }
  };

  function getNotification() {
    getList({
      listUrl: "/api/notifications/byuserid/" + user.id,
    }).then((res) => {
      console.log("notification", res);
      store.setsystemvalue("Notification", res?.data || []);
    });

    getList({
      listUrl: "/api/notifications/unreadcount/" + user.id,
    }).then((res) => {
      store.setsystemvalue("UnreadNotificationCount", res?.data?.unreadCount || 0);
    });
  }

  function formatNotificationTime(value) {
    if (!value) return "";

    const diffMs = Date.now() - new Date(value).getTime();
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;

    return new Date(value).toLocaleString();
  }

  const fetchMonthEvents = useCallback(async () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth(); // 0-based (July is 6)

    try {
      const res = await getList({
        listUrl: getDynamicTableURL(),
        field: "dueDate",
        search: '',
        sort: "asc",
        count: 5000,
        store: store,
      });

      const allTasks = res?.data?.list || [];

      const hasCurrentMonthTasks = allTasks.some((task) => {
        const due = new Date(task.dueDate);
        return (
          due.getFullYear() === year &&
          due.getMonth() === month // Matches current month
        );
      });

      setHasTasksThisMonth(hasCurrentMonthTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
    }
  }, [currentDate]);


  function getBadgesCount() {
    GetRecords(`/users/users/` + user.id).then(async (res) => {
      store.setsystemvalue("badgecount", res?.record?.badgecount);
      console.log("badgecount**", store.getsystemvalue("badgecount"));
    });
  }

  function getCompanyList() {
    if (user.role != 1) {
      GetRecords(`/api/v2/accountingcompany/getcompanybyuserid/` + user.id).then(
        async (res) => {
          setCompanies(res?.record?.list || []);
          store.setsystemvalue("companies", res?.record?.list || []);
          console.log("companies acc", companies);
        }
      );
    } else {
      GetRecords(`/api/v2/accountingcompany/getallcompanies`).then(
        async (res) => {
          setCompanies(res?.record?.list || []);
          store.setsystemvalue("companies", res?.record?.list || []);
          console.log("companies acc", companies);
        }
      );
    }
  }

  const togglePopup = (field) => {
    let newfield = {};
    if (field === "notification") {
      newfield = {
        notification: !isPopupVisible.notification,
        profile: false,
        accounts: false,
      };
    } else if (field === "accounts") {
      newfield = {
        notification: false,
        profile: false,
        accounts: !isPopupVisible.accounts,
      };
    } else {
      newfield = {
        notification: false,
        profile: !isPopupVisible.profile,
        accounts: false,
      };
    }
    setPopupVisible((prev) => {
      prev = newfield;
      return { ...prev };
    });
  };

  return (
    <div 
      style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))', 
        height: '100%', 
        borderBottom: '1px solid #E2E8F0', 
        backgroundColor: '#FFFFFF', 
        paddingLeft: '24px', 
        paddingRight: '24px',
        boxShadow: '0 4px 20px -2px rgba(148, 163, 184, 0.08), 0 2px 8px -1px rgba(148, 163, 184, 0.04)'
      }}
    >
      {/* Brand Logo area */}
      <div className="col-span-2" style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            store.navTo("/" + URLPRIFIX + "/dashboard");
          }}
        >
          <img
            src="/Assets/images/Logo.png"
            alt="Logo"
            style={{ height: '38px', objectFit: 'contain' }}
          />
        </div>
      </div>

      {/* Page Header Title */}
      <div className="col-span-5" style={{ display: 'flex', alignItems: 'center' }}>
        <div 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            paddingLeft: '16px', 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #1E293B 0%, #475569 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.025em', 
            fontSize: '18px',
            fontFamily: 'Inter, sans-serif'
          }}
        >
          {store.getheader().toUpperCase()}
        </div>
      </div>

      {/* Actions and Profile Area */}
      <div className="col-span-5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
        <div className="max-sm:hidden" style={{ display: 'flex', alignItems: 'center', gap: '14px', position: 'relative', height: '100%' }}>
          
          {/* Calendar Icon Button */}
          <button
            onClick={(e) => {
              e.preventDefault();
              store.navTo(`/${URLPRIFIX}/calendarpage`);
            }}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              width: '38px', 
              height: '38px', 
              borderRadius: '12px', 
              border: 'none', 
              backgroundColor: '#EEF2FF', 
              color: '#4F46E5', 
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 2px 4px rgba(79, 70, 229, 0.05)'
            }}
            onMouseEnter={(e) => { 
              e.currentTarget.style.backgroundColor = '#E0E7FF'; 
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(79, 70, 229, 0.1)';
            }}
            onMouseLeave={(e) => { 
              e.currentTarget.style.backgroundColor = '#EEF2FF'; 
              e.currentTarget.style.transform = 'translateY(0px)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(79, 70, 229, 0.05)';
            }}
            title="Go to Calendar"
          >
            <Badge
              color="primary"
              variant="dot"
              invisible={!hasTasksThisMonth}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "6px",
                  minWidth: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  backgroundColor: "#4F46E5",
                  right: 1,
                  top: 1,
                },
              }}
            >
              <VscCalendar size={18} />
            </Badge>
          </button>

          {/* Badges / Ribbon Button */}
          <button
            onClick={(e) => {
              e.preventDefault();
              store.navTo(`/${URLPRIFIX}/tasks/badgeTask/${user.id}`);
            }}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              width: '38px', 
              height: '38px', 
              borderRadius: '12px', 
              border: 'none', 
              backgroundColor: '#ECFDF5', 
              color: '#059669', 
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 2px 4px rgba(5, 150, 105, 0.05)'
            }}
            onMouseEnter={(e) => { 
              e.currentTarget.style.backgroundColor = '#D1FAE5'; 
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(5, 150, 105, 0.1)';
            }}
            onMouseLeave={(e) => { 
              e.currentTarget.style.backgroundColor = '#ECFDF5'; 
              e.currentTarget.style.transform = 'translateY(0px)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(5, 150, 105, 0.05)';
            }}
            title="View Badges"
          >
            <Badge
              max={9999}
              badgeContent={store.getsystemvalue("badgecount")}
              showZero={true}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#10B981",
                  color: "white",
                  fontSize: "8px",
                  height: "14px",
                  minWidth: "14px",
                  borderRadius: "50%",
                  top: -2,
                  right: -2,
                },
              }}
            >
              <IoRibbon size={18} />
            </Badge>
          </button>

          {/* Notifications Button */}
          <div style={{ position: 'relative' }}>
            <button
              onClick={(e) => {
                e.preventDefault();
                togglePopup("notification");
                getNotification();
              }}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                width: '38px', 
                height: '38px', 
                borderRadius: '12px', 
                border: 'none', 
                backgroundColor: '#FFF1F2', 
                color: '#E11D48', 
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(225, 29, 72, 0.05)'
              }}
              onMouseEnter={(e) => { 
                e.currentTarget.style.backgroundColor = '#FFE4E6'; 
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(225, 29, 72, 0.1)';
              }}
              onMouseLeave={(e) => { 
                e.currentTarget.style.backgroundColor = '#FFF1F2'; 
                e.currentTarget.style.transform = 'translateY(0px)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(225, 29, 72, 0.05)';
              }}
              title="Notifications"
            >
              <Badge
                color="error"
                badgeContent={unreadNotificationCount}
                invisible={unreadNotificationCount === 0}
                max={99}
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "8px",
                    minWidth: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#EF4444",
                    top: -2,
                    right: -2,
                  },
                }}
              >
                <IoNotificationsCircleOutline size={20} />
              </Badge>
            </button>

            {/* Notifications Popup Card */}
            {isPopupVisible.notification && (
              <div 
                style={{ 
                  position: 'absolute', 
                  top: '120%', 
                  right: 0, 
                  backgroundColor: '#FFFFFF', 
                  minWidth: '340px', 
                  maxHeight: '380px', 
                  padding: '18px', 
                  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', 
                  borderRadius: '16px', 
                  border: '1px solid #E2E8F0', 
                  zIndex: 99999 
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #F1F5F9', paddingBottom: '10px', marginBottom: '12px', gap: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <h3 style={{ fontSize: '12px', fontWeight: '800', color: '#1E293B', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Notifications</h3>
                    {unreadNotificationCount > 0 && (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handleMarkAllAsRead();
                        }}
                        style={{
                          border: 'none',
                          backgroundColor: '#FFF1F2',
                          color: '#E11D48',
                          fontSize: '10px',
                          fontWeight: '800',
                          padding: '4px 8px',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          textTransform: 'uppercase',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#FFE4E6'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#FFF1F2'; }}
                      >
                        Clear All
                      </button>
                    )}
                  </div>
                  <button
                    style={{ border: 'none', backgroundColor: 'transparent', color: '#94A3B8', fontSize: '18px', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => togglePopup("notification")}
                  >
                    &times;
                  </button>
                </div>

                {notifications.length > 0 ? (
                  <div style={{ overflowY: 'auto', maxHeight: '260px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {notifications.map((item, index) => (
                      <div
                        key={item.id || index}
                        onClick={() => handleNotificationClick(item)}
                        style={{
                          padding: '12px',
                          borderRadius: '12px',
                          border: '1px solid ' + (!item.isRead ? '#E0E7FF' : '#F1F5F9'),
                          backgroundColor: !item.isRead ? '#F5F3FF' : '#FFFFFF',
                          cursor: 'pointer',
                          transition: 'all 0.15s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(0.99)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                        }}
                      >
                        <h4 style={{ fontSize: '13px', fontWeight: '700', color: '#4F46E5', margin: 0 }}>{item.title}</h4>
                        <p style={{ fontSize: '12px', color: '#475569', marginTop: '4px', marginBottom: '4px', fontWeight: '500' }}>{item.message || item.body}</p>
                        <p style={{ fontSize: '10px', color: '#94A3B8', margin: 0 }}>
                          {formatNotificationTime(item.createdAt || item.created_at)}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94A3B8', fontSize: '12px', textAlign: 'center', padding: '24px 0' }}>You have no notifications</p>
                )}
              </div>
            )}
          </div>

          {/* Organizations / Accounts Button */}
          {store?.state?.properties?.companies?.view && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  togglePopup("accounts");
                  getCompanyList();
                }}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  width: '38px', 
                  height: '38px', 
                  borderRadius: '12px', 
                  border: 'none', 
                  backgroundColor: '#E0F2FE', 
                  color: '#0284C7', 
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: '0 2px 4px rgba(2, 132, 199, 0.05)'
                }}
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = '#BAE6FD'; 
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(2, 132, 199, 0.1)';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = '#E0F2FE'; 
                  e.currentTarget.style.transform = 'translateY(0px)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(2, 132, 199, 0.05)';
                }}
                title="Organizations"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 8H22"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 13H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 17H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              
              {isPopupVisible.accounts && (
                <div 
                  style={{ 
                    position: 'absolute', 
                    top: '120%', 
                    right: 0, 
                    backgroundColor: '#FFFFFF', 
                    minWidth: '280px', 
                    maxHeight: '350px', 
                    padding: '16px', 
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', 
                    borderRadius: '16px', 
                    border: '1px solid #E2E8F0', 
                    zIndex: 99999 
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #F1F5F9', paddingBottom: '8px', marginBottom: '12px' }}>
                    <h3 style={{ fontSize: '11px', fontWeight: '800', color: '#1E293B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Organizations</h3>
                    <button
                      style={{ border: 'none', backgroundColor: 'transparent', color: '#94A3B8', fontSize: '16px', cursor: 'pointer' }}
                      onClick={() => togglePopup("accounts")}
                    >
                      &times;
                    </button>
                  </div>

                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '6px', overflowY: 'auto', maxHeight: '240px' }}>
                    {companies.length > 0 ? (
                      companies.map((company) => (
                        <li
                          key={company.id}
                          style={{
                            padding: '8px',
                            borderRadius: '10px',
                            border: '1px solid transparent',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            transition: 'all 0.15s'
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#F8FAFC'; e.currentTarget.style.borderColor = '#F1F5F9'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = 'transparent'; }}
                          onClick={() => {
                            let local = getFulllocal();
                            local.system.user = {
                              ...local?.system?.user,
                              company: company.id,
                            };
                            if ([1, 4].includes(user.role)) {
                              store.navTo(`/${URLPRIFIX}/${company.id}/accounts/dashboard`);
                            } else {
                              store.navTo(`/${URLPRIFIX}/${company.id}/accounts/expense`);
                            }
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <img
                               style={{ width: '24px', height: '24px', borderRadius: '6px', backgroundColor: '#F8FAFC', objectFit: 'cover', border: '1px solid #E2E8F0' }}
                               src={
                                company.company_logo
                                  ? `${baseurl}/files/preview?key=${encodeURIComponent(
                                    company.company_logo
                                  )}`
                                  : "/Assets/images/accounts.png"
                              }
                              alt={company.company_name}
                            />
                            <span style={{ fontSize: '12px', fontWeight: '700', color: '#334155' }}>
                              {company.company_name}
                            </span>
                          </div>
                          <svg
                            style={{ width: '12px', height: '12px', color: '#94A3B8' }}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                            />
                          </svg>
                        </li>
                      ))
                    ) : (
                      <li style={{ color: '#94A3B8', fontSize: '11px', textAlign: 'center', padding: '16px 0' }}>No companies found</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          )}

          {/* User Profile Pill button & popup */}
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <button
              onClick={() => togglePopup("profile")}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '6px 14px',
                borderRadius: '24px',
                background: 'linear-gradient(135deg, #110f36 0%, #2563EB 100%)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.25s',
                boxShadow: '0 4px 12px rgba(11, 6, 109, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(79, 70, 229, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(79, 70, 229, 0.2)';
              }}
            >
              <div 
                style={{ 
                  width: '24px', 
                  height: '24px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FFFFFF', 
                  color: '#4F46E5', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontSize: '11px', 
                  fontWeight: '800',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                {user.name ? user.name[0].toUpperCase() : "U"}
              </div>
              <span style={{ fontSize: '12px', fontWeight: '800', color: '#FFFFFF', letterSpacing: '0.025em' }}>
                {user.name || "User"}
              </span>
              <span style={{ fontSize: '9px', color: '#E0E7FF' }}>▼</span>
            </button>

            {isPopupVisible.profile && (
              <div 
                style={{ 
                  position: 'absolute', 
                  top: '125%', 
                  right: 0, 
                  backgroundColor: '#FFFFFF', 
                  minWidth: '240px', 
                  padding: '0', 
                  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', 
                  borderRadius: '16px', 
                  border: '1px solid #E2E8F0', 
                  zIndex: 99999,
                  overflow: 'hidden'
                }}
              >
                <div style={{ background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)', padding: '16px', borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h3 style={{ fontSize: '13px', fontWeight: '800', color: '#1E293B', margin: 0 }}>{user.name?.toUpperCase()}</h3>
                    <span style={{ fontSize: '10px', color: '#64748B', fontWeight: '600' }}>User Account</span>
                  </div>
                  <button
                    style={{ border: 'none', backgroundColor: 'transparent', color: '#94A3B8', fontSize: '18px', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => togglePopup("profile")}
                  >
                    &times;
                  </button>
                </div>

                <div style={{ padding: '8px' }}>
                  {store?.state?.properties?.users?.view && (
                    <button
                      onClick={() => {
                        store.navTo("/" + URLPRIFIX + "/users/profile/" + user.id);
                        togglePopup("profile");
                      }}
                      style={{
                        width: '100%',
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                        color: '#475569',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'all 0.15s'
                      }}
                      onMouseEnter={(e) => { 
                        e.currentTarget.style.backgroundColor = '#EEF2FF'; 
                        e.currentTarget.style.color = '#4F46E5'; 
                      }}
                      onMouseLeave={(e) => { 
                        e.currentTarget.style.backgroundColor = '#FFFFFF'; 
                        e.currentTarget.style.color = '#475569'; 
                      }}
                    >
                      <span style={{ color: '#4F46E5' }}>👤</span> My Profile
                    </button>
                  )}
                  <button
                    onClick={() => {
                      store.logout();
                    }}
                    style={{
                      width: '100%',
                      padding: '10px 14px',
                      borderRadius: '10px',
                      border: 'none',
                      backgroundColor: '#FFFFFF',
                      color: '#EF4444',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.15s'
                    }}
                    onMouseEnter={(e) => { 
                      e.currentTarget.style.backgroundColor = '#FFF1F2'; 
                    }}
                    onMouseLeave={(e) => { 
                      e.currentTarget.style.backgroundColor = '#FFFFFF'; 
                    }}
                  >
                    <span>🚪</span> Logout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Mobile menu trigger */}
        <div className="items-center justify-center h-full gap-6 max-sm:flex hidden">
          <div
            className="text-[38px] transition-transform duration-200 hover:scale-110 cursor-pointer text-slate-700"
            onClick={(e) => {
              e.preventDefault();
              setsider((prev) => {
                if (prev === "max-sm:hidden") {
                  prev = "max-sm:block";
                } else {
                  prev = "max-sm:hidden";
                }
                return prev;
              });
            }}
          >
            <GiHamburgerMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
